export const AppName = 'IR Portal';

export type ArrayElement<T> = T extends (infer U)[] ? U : never;
